<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card class="px-4 py-4">
      <v-card-title>
        Nova Avaliação Nacional
      </v-card-title>
      <v-progress-linear
        v-if="loading"
        color="amber"
        indeterminate
      />
      <v-form
        ref="form"
      >
        <v-text-field
          v-model="title"
          prepend-icon="mdi-note-text"
          hint="Será exibido no portal"
          persistent-hint
          :error-messages="formErrors.title"
          :disabled="loading"
          label="Titulo da avaliação"
          @input="formErrors.title = ''"
        />
        <v-text-field
          v-model="subtitle"
          prepend-icon="mdi-note-text"
          hint="Será exibido no portal"
          persistent-hint
          :error-messages="formErrors.subtitle"
          :disabled="loading"
          label="Subtitulo da avaliação (opcional)"
          @input="formErrors.subtitle = ''"
        />
      </v-form>
      <div class="d-flex justify-space-between">
        <v-btn
          color="primary"
          text
          @click="onCancel"
        >
          fechar
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="onSubmit()"
        >
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import dayjs from '@/dayjs.js'

export default {
  mixins: [
    handlesServerValidation
  ],

  data: () => ({
    title: null,
    subtitle: null,
    loading: false
  }),
  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async onSubmit () {
      this.loading = true
      try {
        const data = {
          title: this.title,
          subtitle: this.subtitle
        }
        await this.$api.newExam(data)
        this.$store.dispatch('setSnackBar', { text: 'Avaliação criada com sucesso.' })
        this.$emit('resolve', true)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao tentar criar a avaliação.', color: 'red' })
        this.getErrors(e)
      } finally {
        this.loading = false
      }
    },
    dayjs
  }
}
</script>
